'use client'

import Script from 'next/script'
import { useEffect, useState } from 'react'
import { useConsentReady } from '@/hooks/useConsentReady'
import { useIsPurMode } from '@/hooks/useIsPurMode'
import { RequestCookie } from 'next/dist/compiled/@edge-runtime/cookies'

declare global {
  interface Window {
    OBR?: any
  }
}

export const Outbrain = ({ cookies }: { cookies: RequestCookie[] }) => {
  const consentReady = useConsentReady()
  const isPurMode = useIsPurMode(cookies)
  const [loadScript, setLoadScript] = useState<boolean>(false)

  useEffect(() => {
    setLoadScript(consentReady && !isPurMode)
  }, [consentReady])

  return (
    loadScript && (
      <Script
        id="outbrain-sdk"
        src="https://widgets.outbrain.com/outbrain.js"
        strategy="lazyOnload"
        async
        onLoad={() => {
          console.log('[OBR] Outbrain script loaded')
        }}
        onError={(error) => {
          console.error('[OBR] Error while loading Outbrain script ', error)
        }}
      />
    )
  )
}
